
import Button from '@/components/UI/button/Button.vue';
import Icon from '@/components/UI/Icon.vue';

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Button,
    Icon,
  },
})
export default class AddRolledServiceCodeDialog extends Vue {
  @Prop({ type: Boolean, required: true, default: false }) public showModal: boolean;
  @Prop({ type: Boolean, default: false }) public loading: boolean;

  public isAddRolledServiceCodeDialogOpen = false;
}
